import _ from 'underscore';

import tooltipTemplate from '../template/tooltip.pug';

const styles = {
  chartColorBlue: '#0078D4',
  chartColorDarkBlue: '#eee',
  chartColorLightBlue: 'rgba(135, 206, 250, 1)',
};

const barChartOptions = {
  chart: {
    type: 'bar',
    marginLeft: 0,
    marginTop: 0,
    marginBottom: 0,
  },
  title: {
    text: null,
  },
  yAxis: {
    tickPositions: [],
    gridLineWidth: 0,
  },
  legend: {
    enabled: false,
  },
  credits: {
    enabled: false,
  },
  tooltip: {
    enabled: true,
    formatter: null,
  },
  plotOptions: {
    bar: {
      animation: false,
      pointWidth: 25,
    },
    series: {
      cursor: 'pointer',
      point: {
        events: {
          click: null,
        },
      },
      states: {
        hover: {
          enabled: false,
        },
        inactive: {
          enabled: false,
        },
      },
    },
  },
};

export function initChart({
  seriesName,
  i18n,
  selectedRowIndex,
  points,
  onPointClicked,
  budgetPoints,
  isBudgetColumnSelected,
}) {
  const chartOptions = _.clone(barChartOptions);

  const spaceBetweenBar = 5;
  const pointWidthWithPadding = chartOptions.plotOptions.bar.pointWidth + spaceBetweenBar;
  // 4 is for space between chart outer line and first/last bar to ensure space between bar is 5px.
  chartOptions.chart.height = (points.length * pointWidthWithPadding) + 4;

  chartOptions.colors = [styles.chartColorLightBlue, styles.chartColorDarkBlue];
  let seriesColorChanged = false;
  const stylesChartColor = styles.chartColorBlue;
  const mappedResult = _.map(points, (point, index) => {
    const color = index === selectedRowIndex ? stylesChartColor : styles.chartColorDarkBlue;
    if (!seriesColorChanged) {
      chartOptions.colors = [styles.chartColorDarkBlue, stylesChartColor];
      seriesColorChanged = true;
    }
    return {
      color,
      y: point,
    };
  }, this);

  const dataMin = 0; // for the custom input
  const dataMax = Math.ceil(mappedResult[0].y);
  const positions = [];

  const increment = Math.ceil((dataMax - dataMin) / 40) * 10;
  for (let tick = 0; tick - increment < dataMax; tick += increment) {
    positions.push(tick);
  }
  chartOptions.yAxis.tickPositions = positions;

  chartOptions.series = [{
    name: seriesName,
    data: mappedResult,
  }];

  /* eslint-disable func-names */
  chartOptions.plotOptions.series.point.events.click = function (event) {
    event.stopImmediatePropagation();
    onPointClicked(event, this.x);
  };

  chartOptions.tooltip.formatter = function () {
    const value = i18n.formatDecimal(this.y);
    return tooltipTemplate({
      name: this.series.name,
      value,
      primaryMetricName: i18n.getString('ColumnName_EstimatedBudget'),
      primaryMetricValue: budgetPoints[this.x],
      showPrimaryMetric: !isBudgetColumnSelected,
    });
  };
  /* eslint-enable  func-names */
  return chartOptions;
}
